module.exports = __webpack_public_path__ + "static/media/IMG_042.827cb852.JPG";